module.exports = __webpack_public_path__ + "media/images/bang-35dde09fbc88f910673bf6ff0b15ca0c.svg";